export const TipSection = () => (
  <div className="mt-auto border-t border-gray-200 pt-2">
    <div className="rounded-md bg-blue-50 p-2">
      <p className="text-xs text-blue-700">
        <span className="font-medium">Tip:</span> Drag column headers to reorder
      </p>
    </div>
  </div>
);
